export default __webpack_public_path__ + "static/media/match3.f35b12d0.jpg";